export default {
  title: {
    en: 'Shop',
  },
  shop: {
    en: 'Shop',
  },
  makeup: {
    en: 'Makeup',
  },
}
